export default __webpack_public_path__ + "static/media/Express.70ef50a2.png";